import { Cell } from 'react-table';
import { FoodItem } from '../types';

const categoriesColumns = [
  {
    id: 'select',
    Header: ({ getToggleAllRowsSelectedProps }: any) => (
      <input type="checkbox" {...getToggleAllRowsSelectedProps()} />
    ),
    Cell: ({ row }: any) => (
      <input
        type="checkbox"
        {...row.getToggleRowSelectedProps()}
        onClick={(e) => e.stopPropagation()}
      />
    ),
  },
  {
    Header: 'Category Name',
    accessor: 'name',
  },
  {
    Header: 'Date Created',
    accessor: 'createdAt',
  },
  {
    Header: 'Food items',
    accessor: 'foodItems',
    Cell: ({ row }: Cell) =>
      row.values.foodItems.map((item: FoodItem) => item.name).join(', '),
  },
  {
    Header: 'Featured',
    accessor: 'featured',
    Cell: ({ row }: any) => (
      <span
        className={`px-2 py-1 rounded-full text-xs font-medium ${
          row.original.featured
            ? 'bg-green-100 text-green-700'
            : 'bg-gray-100 text-gray-600'
        }`}
      >
        {row.original.featured ? 'Yes' : 'No'}
      </span>
    ),
  },
  {
    Header: 'Action',
  },
];

export const marketingCategoriesColumns = [
  {
    Header: 'Category Name',
    accessor: 'name',
  },
  {
    Header: 'Date Created',
    accessor: 'createdAt',
  },
  {
    Header: 'Position',
    accessor: 'position',
  },
  {
    Header: 'Food items',
    accessor: 'foodItems',
    Cell: ({ row }: Cell) =>
      row.values.foodItems.map((item: FoodItem) => item.name).join(', '),
  },
  {
    Header: 'Action',
  },
];

export const categoriesRankColumns = [
  {
    Header: 'Category',
    accessor: 'category',
    Cell: ({ row }: Cell) => row.values.category?.name,
  },
  {
    Header: 'Date Created',
    accessor: 'createdAt',
  },
  {
    Header: 'Position',
    accessor: 'position',
  },
  {
    Header: 'Food items',
    accessor: 'foodItems',
    Cell: ({ row }: Cell) =>
      row.values.category?.foodItems
        ?.map((item: FoodItem) => item.name)
        .join(', '),
  },
  {
    Header: 'Action',
  },
];

export { categoriesColumns };
